/* eslint-disable react/no-unused-class-component-methods */
'use strict';

import React, { Component } from 'react'

import getErrorsFromResponse from '@/Form/Functions/getErrorsFromResponse'

import FormStatus from '@/Form/FormStatus'

import Message from '@Pure/Message'
import Loader  from '@Pure/Loader'

import Modal  from '@Modal/Modal'

const { qwest, app } = window;

export default class DeleteUserConfirmationModal extends Component
{
	state =
	{
		open: false,
		data: { }
	};

	componentDidMount ()
	{
		const component = this, props = this.props, state = this.state;

		component.setState({ error: undefined, warning: undefined, info: undefined });

		app.push(
		{
			event: 'open__DeleteUserConfirmationModal',
			cb: component.open
		});

		app.push(
		{
			event: 'deletedUser',
			cb: component.handleUserDeletion
		});
	}

	componentWillUnmount ()
	{
		const component = this, props = this.props, state = this.state;

		app.delete(
		{
			event: 'open__DeleteUserConfirmationModal',
			cb: component.open
		});

		app.delete(
		{
			event: 'deletedUser',
			cb: component.handleUserDeletion
		});
	}

	handleClose = (e, force) =>
	{
		const component = this, props = this.props, state = this.state;

		if (state.loading === true && !force)
		{
			e.stopPropagation();
			return;
		}

		component.setState(
		{
			open: false,
			loading: false
		});
	}

	open = (data) =>
	{
		const component = this, props = this.props, state = this.state;

		component.setState(
		{
			open : true,
			data: data
		});
	}

	handleUserDeletion = () =>
	{
		const component = this, props = this.props, state = this.state;

		component.handleClose(null, true);
	}

	delete = (e) =>
	{
		const component = this, props = this.props, state = this.state;

		if (!state.data.id) return;

		component.setState(
		{
			loading: true,
			info: undefined,
			error: undefined,
			warning: undefined
		});

		qwest.post('/users/delete-EC-user',
		{
			id: state.data.id
		})
		.then(function (xhr, response)
		{
			app.emit('deletedUser', response.deleted);

			component.handleClose(e, true);
		})
		.catch(function (error, xhr, response)
		{
			app.ajaxRedirectLogin(response);

			component.setState(
			{
				...getErrorsFromResponse(
				{
					response: response
				})
			});
		});
	}

	render ()
	{
		const props = this.props, component = this, state = this.state;

		let loader;

		if (state.loading === true)
		{
			loader = <Loader className="c-loader" bemit={ ['secondary', 'bg-white'] } />;
		}

		let output =
		(
			<Modal open={ state.open } onClose={ component.handleClose }
				title="Suppression" hide_close={ true }>

				<Message color="red">
					Voulez-vous vraiment supprimer cet utilisateur&nbsp;? Cette action est irréversible. Les commandes et billets électroniques seront supprimés définitivement (Synergies ne pourra pas les restaurer)
				</Message>

				<div className="u-center">

					<div className="name-in-modal">

						{ state.data['firstname'] + ' ' +
							state.data['lastname'] }
					</div>

				</div>

				<FormStatus error={ state.error } info={ state.info }
					warning={ state.warning }
				/>

				<div className="c-dialog__buttons">

					<button type="button"
						className="c-btn c-dialog__danger c-btn--red u-margin-right-15"
						onClick={ component.delete }>
						Supprimer
					</button>

					<button type="button" className="c-btn c-dialog__cancel"
						onClick={ component.handleClose }>
						Fermer
					</button>

				</div>

				{ loader }

			</Modal>
		);

		return output;
	}
}
